import React from "react";

const CamOn = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="10.9463"
        width="16.3702"
        height="12.2958"
        rx="1.21875"
        fill="#FA544D"
      />
      <path
        d="M20.621 17.7903C20.0954 17.4747 20.0954 16.7128 20.621 16.3972L28.4616 11.6894C29.0031 11.3642 29.6923 11.7543 29.6923 12.386L29.6923 21.8015C29.6923 22.4332 29.0031 22.8233 28.4616 22.4981L20.621 17.7903Z"
        fill="#FA544D"
      />
    </svg>
  );
};

export default CamOn;
